/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RouteAnnonsUnavailableReasonEnum =
  (typeof RouteAnnonsUnavailableReasonEnum)[keyof typeof RouteAnnonsUnavailableReasonEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RouteAnnonsUnavailableReasonEnum = {
  MissingCoordinates: 0,
  NoLogisticsCenterNearStart: 1,
  NoFacilityNearEnd: 2,
  BudgetExhausted: 3,
  NoWayToLogisticsCenter: 4,
  DoesNotFitDay: 5,
  FacilityTooFarFromEnd: 6,
  ApproachNotChecked: 7,
  FacilityLocked: 8,
} as const;
